var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-radio-button-list-item-circle",attrs:{"checked":_vm.checked},on:{"click":_vm.click}},[_c('div',{staticClass:"outer-circle",class:{ gray: !this.checked }},[(_vm.checked)?_c('div',{staticClass:"inner-circle"}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }